import { useEffect, useState } from "react";
import { ModelWrapper } from "../../component/ModelWrapper";
import { Link, useNavigate } from "react-router-dom";
import { Interested } from "./Interested";
import { FormattedMessage } from "react-intl";
import { DateFormat } from "sr/helpers/functions/DateFormat";
import { Spinner } from "sr/helpers";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { useGet } from "../../Hooks/Api/useGet";
import { getContractor } from "sr/utils/api/company/workorder/getContractor";
import { HirePopup } from "./HirePopup";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import {
  BACKGROUND_CHECK_STATUSES,
  STRIPE_ONBOARDING_STATUSES,
} from "sr/constants/common";
export const TableRow = ({
  data,
  setActiveTab,
  activeTab,
  shortlistonClick,
  rejectonClick,
  maybeonClick,
  fetchCandidate,
}) => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const {
    getData: FetchContractor,
    loader: contractorLoader,
    data: contractors,
  } = useGet();
  const [showHired, setShowHired] = useState(false);
  const HandleModelByProps = (data) => {
    setShowModal(data);
  };
  const [companyId, setCompanyId] = useState();

  useEffect(() => {
    const userData = getUserDetails();
    setCompanyId(userData?.user_id);
  }, []);

  const getContractorDetails = async (company_id, cleaner_id) => {
    const queryParams = new URLSearchParams();
    if (company_id) queryParams?.append("company_id", company_id);
    if (cleaner_id) queryParams?.append("cleaner_id", cleaner_id);
    await FetchContractor(() => getContractor(queryParams));
  };
  useEffect(() => {
    if (companyId) {
      getContractorDetails(companyId, data?.cleaner_id?._id);
    }
  }, [companyId]);
  const HandleConvert = async () => {
    navigate(`/convert-contractor?id=${data?.id}`);
  };
  const CheckConverted = (cleaner_id) => {
    const data = contractors?.some(
      (item) => item?.cleaner_id?._id === cleaner_id,
    );
    return data;
  };
  const onCheckModel = () => {
    setShowHired(false);
  };
  return (
    <>
      {loader && <LoaderFullScreen />}
      <tr className="bg-white border-b  hover:bg-gray-50">
        <th
          scope="row"
          className="px-6 py-4 font-medium text-gray-900 !normal-case"
        >
          <Link to={`/candidate-details/${data?.id}`}>
            <div className="text-base  text-[#0078ae] cursor-pointer flex gap-2 items-center">
              {data?.cleaner_id?.first_name} {data?.cleaner_id?.last_name}
              {((data?.cleaner_id?.backgroundCheckStatus != undefined &&
                [
                  BACKGROUND_CHECK_STATUSES.CLEAR,
                  BACKGROUND_CHECK_STATUSES.CONSIDER,
                ].indexOf(data?.cleaner_id?.backgroundCheckStatus) !== -1) ||
                data?.cleaner_id?.stripe_customer_model
                  ?.stripe_onboarding_status ===
                  STRIPE_ONBOARDING_STATUSES.SUCCESS) && (
                  <span className="relative group w-6 h-6 inline">
                    <img
                      src="/media/icons/checkr-badge-pink-NB.png"
                      alt="Background check verified"
                      className="w-6 h-6"
                    />

                    {/* Tooltip */}
                    <div className="absolute left-0 top-full pt-2 w-52 hidden group-hover:block z-50">
                      <div className="bg-gray-900 text-white text-xs rounded-lg p-3 shadow-lg leading-relaxed">
                        Background Check Verified User
                      </div>
                    </div>
                  </span>
                )}
            </div>
            <div className="text-base">
              Applied: {DateFormat(data?.createdAt)}
            </div>
            <p className="text-base text-gray-600">
              Applied to {data?.job_id?.job_title}{" "}
            </p>
          </Link>
        </th>
        <td className="px-6 py-4">
          {data?.cleaner_id?.address?.address_line_1}{" "}
          {data?.cleaner_id?.address?.address_line_2}{" "}
          {data?.cleaner_id?.address?.city} {data?.cleaner_id?.address?.country}{" "}
          {data?.cleaner_id?.address?.postal}
        </td>
        <td className="px-6 py-4">
          <div className="flex space-x-3">
            {String(data?.status).toLowerCase() !== "withdrawn" ? (
              <Interested
                status={data?.status}
                modelonClick={() => setShowModal(!showModal)}
                shortlistonClick={shortlistonClick}
                rejectonClick={rejectonClick}
                maybeonClick={maybeonClick}
              >
                {showModal ? (
                  <>
                    <ModelWrapper
                      rightPosition="-right-20"
                      width="w-36"
                      border="border border-[#0078ae]"
                      HandleModelByProps={HandleModelByProps}
                      showModel={showModal}
                    >
                      <ul className="px-3  text-base font-bold text-[#0078ae] text-center">
                        <Link to={`/candidate-details/${data?.id}`}>
                          <li className="py-2">
                            <FormattedMessage
                              id="RECRUITER.CANDIDATES.TABLE.INTEREST.VIEWPHONE.DETAILS"
                              defaultMessage="View details"
                            />
                          </li>
                        </Link>
                      </ul>
                    </ModelWrapper>
                  </>
                ) : null}
              </Interested>
            ) : null}
            {String(data?.status).toLowerCase() === "withdrawn" ? (
              <></>
            ) : CheckConverted(data?.cleaner_id?._id) ? (
              <div className="rounded-lg  bg-[#ff39b3] font-bold px-5 py-3  text-white cursor-pointer hover:bg-navy">
                Converted
              </div>
            ) : activeTab == "" ? null : (
              <button
                disabled={loader || contractorLoader}
                onClick={() => HandleConvert()}
                className="rounded-lg bg-[#ff39b3] font-bold px-5 py-3  text-white cursor-pointer hover:bg-navy"
              >
                {loader || contractorLoader ? (
                  <Spinner className="flex w-full justify-center" />
                ) : (
                  <FormattedMessage id="RECRUITER.CANDIDATES.TABLE.CONVERT.TO.CONTRACTOR"></FormattedMessage>
                )}
              </button>
            )}
          </div>
        </td>
      </tr>
      {showHired && (
        <HirePopup
          data={data}
          getContractorDetails={getContractorDetails}
          setActiveTab={setActiveTab}
          fetchCandidate={fetchCandidate}
          showHired={showHired}
          onCheckModel={onCheckModel}
        ></HirePopup>
      )}
    </>
  );
};
